// ─── Deterministic matte color palette for company values ────────────────────
const VALUE_COLOR_PALETTE = [
  { bg: '#EDE9FE', text: '#6D28D9' }, // violet
  { bg: '#DBEAFE', text: '#1D4ED8' }, // blue
  { bg: '#D1FAE5', text: '#047857' }, // emerald
  { bg: '#FEF3C7', text: '#B45309' }, // amber
  { bg: '#FCE7F3', text: '#BE185D' }, // pink
  { bg: '#E0E7FF', text: '#4338CA' }, // indigo
  { bg: '#CCFBF1', text: '#0F766E' }, // teal
  { bg: '#FEE2E2', text: '#B91C1C' }, // red
  { bg: '#F3E8FF', text: '#7C3AED' }, // purple
  { bg: '#CFFAFE', text: '#0E7490' }, // cyan
]

export function hashValueColor(valueName: string): { bg: string; text: string } {
  let hash = 0
  for (let i = 0; i < valueName.length; i++) {
    hash = ((hash << 5) - hash + valueName.charCodeAt(i)) | 0
  }
  return VALUE_COLOR_PALETTE[Math.abs(hash) % VALUE_COLOR_PALETTE.length]
}
